import React from 'react';
import { connect } from 'react-redux';
import SetList from './layout/content/catalog/set/list/list';
import SetCard from './layout/content/catalog/set/card/index';
import Loading from './layout/content/loading';
import CategoryInfo from './layout/content/catalog/category/category-info/index';
import RaisedButton from 'material-ui/IconButton';
import IconClose from 'material-ui/svg-icons/content/clear';

import Paper from 'material-ui/Paper';

const Slider = props => {
  const { screen, screenOn, right, dispatch, showCloseButton } = props;
  const styleOn = {
    position: 'absolute',
    left: 0,
    right: screen === 'categoryData' ? 176 : 0,
    top: 0,
    minHeight: document.getElementById('root').scrollHeight + 'px',
    background: 'rgb(242, 242, 242)',
    borderRight: '1px solid #ddd',
    zIndex: 9998,
    // overflowY: 'scroll',
    // bottom: 0
  };
  const styleOff = {
    position: 'absolute',
    left: right,
    right: screen === 'categoryData' ? 186 : 0,
    top: 0,
    background: 'rgb(242, 242, 242)',
    padding: '10px'
  };
  const closeStyle ={
    position: 'fixed',
    right: screen === 'categoryData' ? 180 : '10px',
    top: '0px'
  }
  return (
    <Paper style={screenOn ? styleOn : styleOff} rounded={false} zDepth={0}>
      {screenOn && showCloseButton &&
        <div style={closeStyle}>
          <RaisedButton
            label='Закрыть'
            iconStyle={{fill: 'rgba(0,0,0,0.7)', width: '32px', height: '32px'}}
            style={{padding: '0px'}}
            onClick={
              () => {
                dispatch({
                  type: 'RESET_CATEGORY_MENU_ITEM_ACTIVE_KEY'
                })
                dispatch({
                  type: 'SET_SCREEN',
                  name: screen,
                  val: false
                });
              }
            }
          >
            <IconClose />
          </RaisedButton>
        </div>
      }
      {screen === 'modelSets'    && <SetList /> }
      {screen === 'setCard'      && <SetCard /> }
      {screen === 'categoryData' && <CategoryInfo /> }
      {screen === 'loading'      && <Loading /> }

    </Paper>
  );
}

Slider.defaultProps = {
  showCloseButton: true
}

const mapStateToProps = (state, ownProps) => {
  return {
    screenOn: state.ui.screens[ownProps.screen],
    screen: ownProps.screen,
    right: state.ui.categoryMenuItemPos.right,
    top: state.ui.categoryMenuItemPos.top
  }
}

export default connect(
  mapStateToProps
)(Slider);



// WEBPACK FOOTER //
// ./src/components/screen.js